import 'lightslider';

import './animate-section';
import './blog';
import './form';
import './header';
import './staff';

$(document).ready(() => {

  $('[carousel]').each(function(){
    $(this).lightSlider({
      adaptiveHeight: true,
      item: getCarouselItems($(this).data('num-items')),
      loop: true,
      nextHtml: $(this).data('next-html') || '',
      pager: false,
      prevHtml: $(this).data('prev-html') || '',
    });
  });

  $('[hero-carousel]').each(function(){
    $(this).lightSlider({
      adaptiveHeight: true,
      item: 1,
      loop: true,
      nextHtml: $(this).data('next-html') || '',
      prevHtml: $(this).data('prev-html') || '',
    });
  });


  const scrollToId = (id) => {
    const $elem = $(`#${id}`);
    const diff = $elem.offset().top - $(window).scrollTop();
  };

  $('.at-a-glance__actions__item').on('click mouseenter', handleAtAGlanceActions);
  $('.at-a-glance__content').on('mouseenter', atAGlanceEnter);
  $('.at-a-glance__content').on('mouseleave', startAtAGlanceTimeout);

  const glanceItemLength = $('.at-a-glance__actions__item').length - 1;
  let glanceIndex = 0;
  let glanceInterval;

  // startAtAGlanceTimeout();

  function handleAtAGlanceActions(){
    glanceIndex = $(this).index();
    if (!$(this).hasClass('at-a-glance__actions__item--active')) {
      $('.at-a-glance__actions__item--active').removeClass('at-a-glance__actions__item--active');
      $('.at-a-glance__slide--active').removeClass('at-a-glance__slide--active');
      $(this).addClass('at-a-glance__actions__item--active');
      const slide = $(this).data('slide-ref');
      $(`[data-slide="${slide}"]`).addClass('at-a-glance__slide--active');
    }
  }

  function startAtAGlanceTimeout() {
    if (!window.matchMedia("(max-width: 768px)").matches) {
      glanceInterval = setInterval(() => {
        if (glanceIndex++ >= glanceItemLength) {
          glanceIndex = 0;
        }
        $('.at-a-glance__actions__item').eq(glanceIndex).click();
      }, 8000);
    }
  }

  function getCarouselItems(elemValue){
    if (window.matchMedia("(max-width: 768px)").matches) {
      return 1;
    }

    if (window.matchMedia("(max-width: 1100px)").matches) {
      return 2
    }
    return elemValue || 3;
  }

  function atAGlanceEnter(){
    clearInterval(glanceInterval);
  }
});
